import React, { useEffect } from "react";

// gallary
import Gallery1 from "../images/gallery-1.jpg";
import Gallery2 from "../images/gallery-2.jpg";
import Gallery3 from "../images/gallery-3.jpg";
import Gallery4 from "../images/gallery-4.jpg";
import Gallery5 from "../images/gallery-5.jpg";
import Gallery6 from "../images/gallery-6.jpg";
import Gallery7 from "../images/gallery-7.jpg";
import Gallery8 from "../images/gallery-8.jpg";


const Gallery = () => {

    const images = [
        Gallery1,
        Gallery2,
        Gallery3,
        Gallery4,
        Gallery5,
        Gallery6,
        Gallery7,
        Gallery8
    ]
    return (
        <>
            <section id="gallery" className="gallery">
                <div className="container-fluid">
                    <div className="section-title">
                        <h1 className="display-5">
                            Some photos from <span className="text-warning">Our Restaurant</span>
                        </h1>
                        <p>
                            Some Glimps of our Restaurant.
                        </p>
                    </div>
                    <div className="row px-2">
                        {
                            images?.map((data) =>
                                <div className="col-lg-3 col-md-4 p-0">
                                    <div className="gallery-item">
                                        <img src={data} alt="" className="img-fluid" />
                                    </div>
                                </div>)
                        }


                    </div>
                </div>
            </section>
        </>
    );
};

export default Gallery;
